// @ts-nocheck
import { connect } from 'react-redux'
import { NotesCard as NotesComponent } from 'transfix-ui/components/NotesCard'
import { getNotes, submitNote, submitCallback } from 'utils/actions/notes'

export const Notes = connect(
  ({
    carrier: { carrierDetails: carrierData },
    notes: { notesAreLoading: fetching, notesError: error, notesList: notes },
  }) => ({
    noteableType: 'CarrierApplication',
    noteableId: carrierData ? carrierData.id : undefined,
    notes,
    fetching,
    error,
  }),
  { getNotes, submitNote, submitCallback }
)(NotesComponent)
